import React from 'react';
import Portlet from '@ui/portlet/Portlet';
import FormInputText from '@ui/form/input/FormInputText';
import FormButton from '@ui/button/FormButton';
import { Integration } from '@app/model/integration-settings/Integration';
import { TYPE_LABEL, TYPE_TEXT } from '../IntegrationSettings.utilities';
import IntegrationHeaderActions from './IntegrationHeaderActions';
import IntegrationCardFooter from './IntegrationCardFooter';
import useIntegrationCard from './useIntegrationCard';
import { IntervalField, MonthsAheadField, ProviderField, StartAtField } from './IntegrationFields';

// Availability: WebHotelier reads the free rooms with one RoomPulse access, so this card has no credential field.
// It needs no room catalogue either, so the card has no catalogue block (ROO2-239).
const AvailabilityCard: React.FunctionComponent<{ integration: Integration, onOpenLog: () => void }> = ({ integration, onOpenLog }) => {
	const card = useIntegrationCard(integration);
	return <div id="availability" className="scroll-mt-6">
		<Portlet isLarge title={TYPE_LABEL.AVAILABILITY}
						actions={<IntegrationHeaderActions integration={integration} onToggle={card.onToggle} isSaving={card.isBusy} />}>
			<p className="text-sm text-gray-500">{TYPE_TEXT.AVAILABILITY} </p>
			<form className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-3" autoComplete="off">
				<ProviderField form={card.form} integration={integration} />
				<FormInputText form={card.form} name="hotelCode" disabled={integration.hotelCode !== null} label="WebHotelier hotel code" isRequired />
				<div>
					<p className="mb-1 text-sm font-medium text-gray-900">API access</p>
					<p className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-500">Managed by RoomPulse</p>
					<p className="help">Shared WebHotelier credentials for all properties. No property key to enter or edit.</p>
				</div>
				<MonthsAheadField form={card.form} type="AVAILABILITY" />
				<IntervalField form={card.form} label="Check every" integration={integration} />
				<StartAtField form={card.form} />
			</form>
			<IntegrationCardFooter integration={integration} onOpenLog={onOpenLog}
														buttons={(card.form.formState.isDirty || integration.status === 'NOT_SET_UP') && <FormButton state="primary" onClick={card.onSave} disabled={card.isBusy}>Save</FormButton>} />
		</Portlet>
	</div>;
};

export default AvailabilityCard;
